module.exports = __webpack_public_path__ + "img/tools.9c09fcb6.png";